import { useRoutes } from "react-router";

import { mobileRoutes } from "./routes";

function MobileAppRouter() {
  return useRoutes(mobileRoutes);
}

export default MobileAppRouter;
